// Firma Dashboard: onaylı / eksik-hatalı sayıları ve 3 gün içinde süresi dolacak talepler
import { Card, CardContent } from '../ui/card';
import { CheckCircle2, AlertCircle, Hourglass, ArrowRight } from 'lucide-react';
import { iso } from '../settings/calendarViews';
import { matchesGroup } from '../dashboard/PermitWidgets';

const DAY = 86400000;
const daysBetween = (a, b) => Math.round((new Date(`${b}T00:00:00`) - new Date(`${a}T00:00:00`)) / DAY);
const fmt = (d) => (d ? d.split('-').reverse().join('.') : '');

const LEVEL = (d) => d <= 1
  ? { label: 'Kritik', cls: 'bg-rose-600 text-white', row: 'border-l-rose-600 bg-rose-50' }
  : d === 2
    ? { label: 'Yaklaşıyor', cls: 'bg-orange-500 text-white', row: 'border-l-orange-500 bg-orange-100/60' }
    : { label: 'Yaklaşıyor', cls: 'bg-yellow-300 text-yellow-900', row: 'border-l-yellow-400 bg-yellow-50/70' };

export const FirmStatusCards = ({ permits, onOpen }) => {
  const cards = [
    ['Onaylandı', 'Onaylanan', CheckCircle2, 'bg-emerald-500', 'firm-dashboard-approved'],
    ['Eksik/Hatalı', 'Eksik/Hatalı', AlertCircle, 'bg-amber-500', 'firm-dashboard-deficient'],
  ];
  return cards.map(([group, label, Icon, color, testid]) => (
    <Card key={group} className="cursor-pointer border-slate-200 transition-shadow hover:shadow-md" onClick={() => onOpen(group)} data-testid={`${testid}-card`}>
      <CardContent className="flex items-center gap-3 p-4 sm:gap-4 sm:p-6">
        <div className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-xl sm:h-12 sm:w-12 ${color}`}><Icon className="h-5 w-5 text-white sm:h-6 sm:w-6" /></div>
        <div className="min-w-0"><p className="truncate text-xs text-slate-500 sm:text-sm">{label}</p><p className="text-2xl sm:text-3xl font-bold text-slate-900" data-testid={testid}>{permits.filter(p => matchesGroup(group, p)).length}</p></div>
      </CardContent>
    </Card>
  ));
};

export const ExpiringPermits = ({ permits, locationName, onView }) => {
  const today = iso(new Date());
  const list = permits
    .filter(p => matchesGroup('Onaylandı', p) && p.end_date && p.end_date >= today && daysBetween(today, p.end_date) <= 3)
    .map(p => ({ ...p, left: daysBetween(today, p.end_date) }))
    .sort((a, b) => a.left - b.left || (a.end_time || '').localeCompare(b.end_time || ''));
  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white" data-testid="firm-expiring-permits">
      <div className="flex items-center justify-between gap-3 border-b border-slate-100 px-4 py-3">
        <div className="flex items-center gap-2"><Hourglass className={`h-5 w-5 ${list.length ? 'text-rose-500' : 'text-slate-300'}`} /><h2 className="font-semibold text-slate-900">3 Gün İçinde Süresi Dolacak Talepler</h2></div>
        <span className="text-xs text-slate-500" data-testid="firm-expiring-count">{list.length} talep</span>
      </div>
      {!list.length ? (
        <p className="flex items-center gap-2 px-4 py-4 text-sm text-emerald-700" data-testid="firm-expiring-empty"><CheckCircle2 className="h-4 w-4" />Yakında süresi dolacak talebiniz yok.</p>
      ) : (
        <ul className="max-h-[32rem] divide-y divide-slate-100 overflow-y-auto">
          {list.map(p => {
            const lv = LEVEL(p.left);
            return (
              <li key={p.id} onClick={() => onView(p)} className={`flex cursor-pointer flex-wrap items-center gap-x-3 gap-y-1.5 border-l-4 px-4 py-3 transition-colors hover:bg-slate-50 sm:flex-nowrap sm:gap-4 ${lv.row}`} data-testid={`firm-expiring-${p.id}`}>
                <code className="text-xs font-semibold text-slate-600">{p.request_number || '-'}</code>
                <div className="min-w-0 flex-1 basis-40">
                  <p className="truncate text-sm font-medium text-slate-800">{locationName(p.location_id)}</p>
                  <p className="truncate text-xs text-slate-500">{[p.is_tipi, p.is_cesidi].filter(Boolean).join(' / ') || p.job_description || '-'}</p>
                </div>
                <div className="order-last w-full text-xs text-slate-600 sm:order-none sm:w-auto sm:text-right">
                  <p>Bitiş: {fmt(p.end_date)}{p.end_time ? ` ${p.end_time}` : ''}</p>
                  <p className="font-semibold" data-testid="firm-expiring-left">{p.left === 0 ? 'Bugün bitiyor' : `${p.left} gün kaldı`}</p>
                </div>
                <span className={`rounded px-2 py-0.5 text-[11px] font-medium ${lv.cls}`} data-testid="firm-expiring-level">{lv.label}</span>
                <ArrowRight className="hidden h-4 w-4 text-slate-400 sm:block" />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};
